export default {
    legalVisitType: "نوع متقاضی",
    date: "تاریخ مراجعه ",
    doctor: "نام پزشک",
    externalDoctor: "نام پزشک خارج از مرکز",
    consultation: "مشاوره دهنده",
    result: "نتیجه مشاوره",
    description: "توضیحات",
    isExternalDoctor: "پزشک خارج از مرکز است",
}
